module.exports = __webpack_public_path__ + "img/cmp_content_img_01.4d5db116.png";